/*
  Semaine Deep Dive plan sticky bar (#lp-dd-sticky).

  Shows once the hero has scrolled above the viewport and hides while the buy
  box (#lp-mbl-shop) is on screen. Uses IntersectionObserver only (no scroll
  listeners). The button carries data-scroll-to="lp-mbl-shop", so the existing
  smooth-scroll delegate in lp-meno-belly.js handles the click; a fallback
  handler below covers pages where that file is missing.

  Lives in assets/ because the theme editor strips inline <script> blocks from
  section markup. Globals are guarded (typeof window.X === 'function').
*/
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('lp-dd-sticky');
    if (!bar) return;
    var hero = document.querySelector('.lp-mbl__hero');
    var shop = document.getElementById('lp-mbl-shop');
    if (!hero || !shop || !('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('.lp-dd-sticky__btn');
    var pastHero = false;
    var shopVisible = false;
    var shown = false;

    function render() {
      var next = pastHero && !shopVisible;
      if (next === shown) return;
      shown = next;
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
      if (btn) btn.setAttribute('tabindex', shown ? '0' : '-1');
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        pastHero = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
      });
      render();
    }, { threshold: 0 }).observe(hero);

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { shopVisible = e.isIntersecting; });
      render();
    }, { threshold: 0 }).observe(shop);

    if (btn && !window.__lpDdStickyClick) {
      window.__lpDdStickyClick = true;
      btn.addEventListener('click', function (ev) {
        if (typeof window.fireEvent === 'function') {
          try { window.fireEvent('lp_dd_sticky_click', { cta: 'see_my_plan' }); } catch (err) { /* ignore */ }
        }
        // lp-meno-belly.js handles [data-scroll-to] at document level and calls
        // preventDefault; only scroll here if nothing else did.
        setTimeout(function () {
          if (ev.defaultPrevented) return;
          var top = shop.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 0);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
